const TOKEN_KEY = "jwt";
export const logIn = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};
export const logOut = () => {
  localStorage.removeItem(TOKEN_KEY);
};
export const isLoggedIn = () => {
  if (localStorage.getItem(TOKEN_KEY)) {
    return true;
  }
  return false;
};
